// src/components/common/ErrorBoundary.jsx
// 컴포넌트 크래시 시 전체 앱 화면이 흰 화면으로 굳는 것을 방지

import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100dvh',
          padding: 24,
          gap: 16,
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 40 }}>⚠️</div>
          <div style={{ fontSize: 17, fontWeight: 700, color: '#111' }}>
            일시적인 오류가 발생했습니다
          </div>
          <div style={{ fontSize: 13, color: '#888', lineHeight: 1.6 }}>
            {this.state.error?.message || '알 수 없는 오류'}
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8,
              padding: '10px 24px',
              background: 'var(--green, #16a34a)',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            앱 새로고침
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
